// extracted by mini-css-extract-plugin
export default {"container":"a3JWMLfeIoF1Q5OCjkHU","icon":"UUHhBeVetDv1QTlqiRpa","title":"PqDYXfFztyVHHPGhypjy","subtitle":"wCQl6L_yUoyj8t381qD0","button":"pxExo3fdaTMmDGNZrfUA"};